import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';
import { NgForm } from '@angular/forms';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { CatastrofeService } from 'src/app/services/catastrofe/catastrofe.service';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';
import Swal from 'sweetalert2';
import { Hijo } from '../../models/hijo/hijo.model';
import { TiposService } from '../../services/tipos/tipos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { DialogTipoRechazo } from '../common/postulacion-rechazar.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { environment } from '../../../environments/environment';
import { isNullOrUndefined } from 'util';
import { isNull } from 'util';
declare const Rut: any;
export interface DialogData {
    //archivo: any;
    archivo: any[];
    archivoTest: any;
    archivoTest2: any;
    archivoTest3: any;
    archivoTest4: any;
    archivoTest5: any;
    archivoTest6: any;


    idPostulacion: any;
    beneficiario: string;
    postulantes: any;
    tipoIngreso: any;
    tipoCatastrofe: any;
    magnitudesDannos: any;
    magnitudDanno: any;
    otro: boolean;
    carga: boolean;
    comunas: any
    comuna: any
    regiones: any
    region: any
    ciudad: any
    tipoNacimiento: any;
    deshabilitado: boolean;
    presionaEditar: boolean;
    recarga: boolean;
    email: string;
    otroTipoCatastrofe: string;
    rutHijo: string;
    tipos: any;
    tiposVivienda: any;
    fechaCatastrofe: any;
    idUsuario: any;
    nombreCompleto: string;
    nombreCompletoHijo: string;
    domicilioCatastrofe: string;
    mostrarEditar: string;
    rol: string;
    disponiblePago: any;
    mostrarAprobarButton: any;
    diasDiferencia: any;
    diasFechaAdopcion: any;
    caracteristicasVivienda: string;
    tipoVivienda: string;
    visitaDomiciliaria: string;
    observacionCatastrofe: string;
    cantidadArchivos: any;
}

@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/postulaciones/postulacion-catastrofe-validar.html',
    styleUrls: ['../../pages/postulaciones/postulaciones.component.css'],
})
export class DialogEditPostulacionCatastrofe {
    constructor(public dialogRef: MatDialogRef<DialogEditPostulacionCatastrofe>,
        public catastrofeService: CatastrofeService,
        public mantenedorUsuariosService: MantenedorUsuariosService,
        private postulacionesService: PostulacionesService,private productosService: ProductosService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog,) {
        let vm = this
        this.data.recarga = false
        this.data.rol = localStorage.getItem('rol')
        this.data.cantidadArchivos = 1;
        this.data.archivo = []
        this.catastrofeService.traeTipoCatastrofe().then(
            tipo => this.data.tipos = tipo
        ).catch(error => console.log(error))

        this.catastrofeService.traeTipoVivienda().then(
            tipo => this.data.tiposVivienda = tipo
        ).catch(error => console.log(error))

        this.catastrofeService.traeMagnitudDanno().then(
            tipos => this.data.magnitudesDannos = tipos
        ).catch(error => console.log(error))

        this.data.otro = false

        this.mantenedorUsuariosService.traeRegiones().then
            (regiones => { vm.data.regiones = regiones })
        this.mantenedorUsuariosService.traeComunas(this.data.region).then
            (comunas => { vm.data.comunas = comunas })

            this.productosService.obtieneProductos().then
            (
              productos => productos[9].parametros.map(parametro => {
              
                if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_CATASTROFE') {
                  vm.data.diasDiferencia = parametro.valor
                }
              })
            )
            .catch(error => console.log(error))
    }

    onRechazarClick(): void {
        let vm = this


        let dataRechazo: any =
        {
            idPostulacion: this.data.idPostulacion, tiposRechazo: [], tipoRechazo: '', email: this.data.email,
            nombreCompleto: this.data.nombreCompleto, nombreProducto: 'NACIMIENTO'
        }

        this.postulacionesService.motivoRechazo(2).then(rechazos => {
            dataRechazo.tiposRechazo = rechazos
        })
            .catch(error => {

                console.log(error)
            });

        const dialogRechazo = this.dialog.open(DialogTipoRechazo, { width: '50%', data: dataRechazo })

        dialogRechazo.afterClosed().subscribe(() => {

            vm.data.recarga = true
            vm.dialogRef.close()
        })
    }

    onAprobarClick(form: NgForm){
        let vm = this
        let titular = true
        let rut = ''
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        if (!isNullOrUndefined(this.data.postulantes) && !isNullOrUndefined(this.data.postulantes[0].tipoCarga)) {
            rut = this.data.postulantes[0].rut
            titular = false
        } else {
            let limpiarRut = this.data.beneficiario.split("(");
            let obtenerRut = limpiarRut[1].split("-");
            rut = obtenerRut[0]
        }
        
        if (!vm.data.tipoVivienda || vm.data.tipoVivienda == '0') {
            Swal.close();
            this.openAlertDialog('Debe seleccionar un tipo de vivienda', 'btn-dark')
            return false
        }

        if (!vm.data.magnitudDanno || vm.data.magnitudDanno == 0) {
            Swal.close();
            this.openAlertDialog('Debe seleccionar el tipo de magnitud del daño', 'btn-dark')
            return false
        }

        if (!vm.data.tipoCatastrofe || vm.data.tipoCatastrofe == 0) {
            Swal.close();
            this.openAlertDialog('Debe seleccionar el tipo de catastrofe', 'btn-dark')
            return false
        }

        let fechaIngresada = new Date(this.data.fechaCatastrofe + 'T00:00')

        let fechaMinima = new Date()
        fechaMinima.setDate(fechaMinima.getDate() - this.data.diasDiferencia)
        let fechaCatIngresada = new Date(this.data.fechaCatastrofe + 'T00:00')

           
        if ((fechaCatIngresada < fechaMinima || fechaCatIngresada > new Date())) {
          this.openAlertDialog('La Fecha de solicitud supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-dark')
          Swal.close();
          return false
        }

        this.postulacionesService.sinPostulacionesVigentes(2, rut, titular).then
            (
                response => {

                    if (fechaIngresada < fechaMinima || fechaIngresada > new Date()) {
                        Swal.close();
                        this.openAlertDialog('La fecha de certificado ingresada no cumple con los estándares establecidos1. Favor revisar.', 'btn-dark')

                    } else {
                        const dialogRef = this.dialog.open(ConfirmationDialog, {
                            data: { message: '¿Esta seguro de aprobar la postulación?', buttonText: { ok: 'Si', cancel: 'No' } }
                        })

                        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                            if (confirmed) {
                                Swal.fire({
                                    allowOutsideClick: false,
                                    icon: 'info',
                                    text: 'Cargando...'
                                });
                                Swal.showLoading();
                                vm.postulacionesService.cambiarEstadoPostulacion(vm.data.idPostulacion, "DISPONIBLE PARA PAGO", idUsuarioSesion).then
                                    (
                                        () => {
                                            vm.data.recarga = true
                                            vm.dialogRef.close()
                                            Swal.close();
                                            vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                                        }
                                    )
                                    .catch
                                    (
                                        error => {
                                            Swal.close();
                                            console.log(error)
                                            vm.dialogRef.close()
                                            vm.openAlertDialog('La postulación no se ha podido aprobar.', 'btn-danger')
                                        }
                                    )
                            }
                        })
                    }

                }
            )
            .catch
            (
                () => {
                    const dialogRef = this.dialog.open(ConfirmationDialog, {
                        data: { message: '¿Esta seguro de aprobar la postulación?', buttonText: { ok: 'Si', cancel: 'No' } }
                    })

                    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                        if (confirmed) {
                            Swal.fire({
                                allowOutsideClick: false,
                                icon: 'info',
                                text: 'Cargando...'
                            });
                            Swal.showLoading();
                            vm.postulacionesService.cambiarEstadoPostulacion(vm.data.idPostulacion, "DISPONIBLE PARA PAGO", idUsuarioSesion).then
                                (
                                    () => {
                                        vm.data.recarga = true
                                        vm.dialogRef.close()
                                        Swal.close();
                                        vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                                    }
                                )
                                .catch
                                (
                                    error => {
                                        Swal.close();
                                        console.log(error)
                                        vm.dialogRef.close()
                                        vm.openAlertDialog('La postulación no se ha podido aprobar.', 'btn-danger')
                                    }
                                )
                        }
                    })
                    // }     

                }
            )

    }

    onEditarClick(): void {
        this.data.deshabilitado = false
        this.data.presionaEditar = true
    }

    onCancelarClick(): void { this.dialogRef.close() }

    onDescargarArchivosClick(postulacionId: any) {
        let vm = this

        vm.postulacionesService.traeArchivos(postulacionId).then
            (
                (archivos: any) => {
                    archivos.forEach(archivo => {
                        var fileURL = `${environment.urlBlob}/${archivo.url}`
                        window.open(fileURL, '_blank')
                    })

                }
            )
            .catch
            (
                error => {
                    console.log(error)
                    vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
                }
            )
    }

    onGuardarClick(form: NgForm) {

        let vm = this
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        let idUsuario = this.data.idUsuario
        let fechaAdopcion = null;

        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });

        Swal.showLoading();
        let usuarioId: any
        let fechaIngresadaNac = new Date(this.data.fechaCatastrofe + 'T00:00')
        let fechamaxima = new Date()    
        let fechaNacIngresada = new Date(this.data.fechaCatastrofe + 'T00:00')
        let fechaMinima = new Date()
    
        fechaMinima.setDate(fechaMinima.getDate() - this.data.diasDiferencia)
        let fechaCatIngresada = new Date(this.data.fechaCatastrofe + 'T00:00')
        
        if ((fechaCatIngresada < fechaMinima || fechaCatIngresada > new Date())) {
          this.openAlertDialog('La Fecha de solicitud supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-dark')
          Swal.close();
          return false
        }

        let fechaAdopIngresada = new Date(this.data.fechaCatastrofe + 'T00:00')
        let fechaMinimaAdopcion = new Date()
        fechaMinimaAdopcion.setDate(fechaMinimaAdopcion.getDate() - this.data.diasFechaAdopcion)


        if (!form.valid) {
            Swal.close();
            this.openAlertDialog('Debe ingresar todos los campos obligatorios', 'btn-dark')
            return false
        }

        if (!vm.data.tipoVivienda || vm.data.tipoVivienda == '0') {
            Swal.close();
            this.openAlertDialog('Debe seleccionar un tipo de vivienda', 'btn-dark')
            return false
        }

        if (!vm.data.magnitudDanno || vm.data.magnitudDanno == 0) {
            Swal.close();
            this.openAlertDialog('Debe seleccionar el tipo de magnitud del daño', 'btn-dark')
            return false
        }

        if (!vm.data.tipoCatastrofe || vm.data.tipoCatastrofe == 0) {
            Swal.close();
            this.openAlertDialog('Debe seleccionar el tipo de catastrofe', 'btn-dark')
            return false
        }
        let fechaCatastrofe = this.data.fechaCatastrofe.split('-')[2] + '-' +
            this.data.fechaCatastrofe.split('-')[1] + '-' +
            this.data.fechaCatastrofe.split('-')[0]

        this.catastrofeService.editarCatastrofe(this.data, fechaCatastrofe, idUsuario, idUsuarioSesion).then
            (
                () => {
                    vm.data.recarga = true
                    vm.dialogRef.close()
                    Swal.close();
                    vm.openAlertDialog('La postulación se ha guardado exitosamente.', 'btn-success')
                }
            )
            .catch
            (
                (error: any) => {
                    vm.dialogRef.close()
                    console.log('error:',error)

                    if (error.status == 406) {
                        vm.openAlertDialog('El afiliado ya tiene una solicitud para el mismo tipo.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 412) {
                        vm.openAlertDialog('Beneficio con fecha de evento anterior a la fecha de afiliación.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 402) {
                        vm.openAlertDialog('Documento emitido en periodo de carencia.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 423) {
                        vm.openAlertDialog('Ya completó tope de catástrofe por anualidad.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 410) {
                        vm.openAlertDialog('Ya completó tope de catástrofe por anualidad.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 417) {
                        vm.openAlertDialog('Existe una solicitud de catastrofe para el mismo día.', 'btn-danger')
                        Swal.close();
                    } else {
                        Swal.close();
                        vm.openAlertDialog('La postulación no se ha logrado guardar.', 'btn-danger')

                    }

                }
            )
        //}
    }

    traeComunas() {
        let vm = this

        this.data.comunas = []
        this.mantenedorUsuariosService.traeComunas(this.data.region).then(comunas => vm.data.comunas = comunas)
    }

    muetraOtros(tipoCatastrofe) {
        let vm = this
        this.data.otro = false;
        vm.data.tipoIngreso = 0
        for (let i = 0; i < this.data.tipos.length; i++) {
            if (this.data.tipos[i].descripcion == 'OTROS') {
                vm.data.tipoIngreso = this.data.tipos[i].id;
            }
        }
        if (vm.data.tipoIngreso == tipoCatastrofe) {
            this.data.otro = true;
        } else {
            this.data.otro = false;
        }
    }

    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    
    sumaArchivo() {
      
        if (this.data.cantidadArchivos <= 6) {
         
            this.data.cantidadArchivos = this.data.cantidadArchivos + 1
        }
    }


    restaArchivo() {
        this.data.cantidadArchivos = this.data.cantidadArchivos - 1
        this.data.archivo.splice(this.data.cantidadArchivos, 1);
    }

    seleccionaArchivo(event: any, numero: number) {
        if (event.target.files.length > 0) {
            let vm = this
            let reader = new FileReader()
            this.data.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
            reader.readAsDataURL(event.target.files[0])

            reader.onload = function () {
                vm.data.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
            }
        }
    }

}
